import type { ApplicationConfig } from './ApplicationConfig';
import { Stage } from './ApplicationConfig';

export const localConfig: ApplicationConfig = {
  apiUrl: 'https://api.skin-seoul.com',
  apiKey: '55930ae6-9ed5-4e63-92a0-bd91fec26a45',
  stage: Stage.LOCAL,
  sheetId: '1CNmHugwnAfmcFjMf1okeUJBsoUtFh7o-ktd7qXrcyEU',
  wpAdminUrl: 'https://dev.skin-seoul.com/wp-admin/',
  adminUrl: 'http://localhost:5173',
};
